import AxiosClient from '@services/api/base'
import routes from '@configs/api'
import { AUTH_TOKEN_KEY } from '@constants/localstorageKeys'
import Cookies from 'js-cookie'

/**
 * Checkout
 * @param code
 * @param items
 * @param isGiftOrder
 */
const validateDiscount = (
  code: string,
  items: any[],
  isGiftOrder = false
): Promise<any> => {
  return new Promise((resolve, reject) => {
    const tokenId = Cookies.get(AUTH_TOKEN_KEY)
    const URL = routes.PAYMENTS + '/discount?isGiftOrder=' + isGiftOrder
    const config = {
      headers: {
        Authorization: `Bearer ${tokenId}`,
      },
    }

    const data = { items, code }
    AxiosClient.post(URL, data, config)
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        reject(err)
      })
  })
}

export default validateDiscount
